import React from 'react';
import { SmallText } from '@ui-library/typography';
import { Form as AntForm } from 'antd';
import styled from 'styled-components';
import { Flex } from '@ui-library/flex';

export type { FormProps } from 'antd';
export type { FormListFieldData, FormListProps } from 'antd/es/form';
export type { FormInstance } from 'antd/es/form/Form';
export type { FormRule } from 'antd';

const OptionalText = styled(SmallText)`
  color: ${({ theme }) => theme.token.colorTextSecondary};
  font-style: italic;
`;

const customizeRequiredMark = (label: React.ReactNode, { required }: { required: boolean }) => (
  <Flex gap=".5rem" alignItems="center">
    {label}
    {!required && <OptionalText>(Optional)</OptionalText>}
  </Flex>
);

const FormList = styled(AntForm.List)``;

export const Form = styled(AntForm).attrs({
  requiredMark: customizeRequiredMark,
})<{ variant?: 'next' }>`
  .ant-form-item-label {
    padding-bottom: ${({ variant }) => (variant ? 0 : 'unset')};
  }

  .ant-form-item-label label {
    font-weight: 500;
    font-size: ${({ theme, variant }) =>
      variant ? theme.token.fontSize : theme.token.fontSizeLG}px;
    height: auto !important;
  }
`;

Form.Item = AntForm.Item;
Form.List = FormList;
